import React, { Fragment } from 'react'
import { Button, Modal } from 'react-bootstrap'
// icons
import {
    faAddressCard,
    faArrowLeft,
    faCashRegister,
    faCheck,
    faChevronCircleUp,
    faFileInvoice,
    faFileInvoiceDollar,
    faIdCard,
    faIdCardAlt,
    faSortAmountDown,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// router
import { withRouter } from 'react-router-dom'
// css
import useFacturaElectronicaModal from '../hooks/useFacturaElectronicaModal'
import './FacturaElectronicaModal.css'

const FacturaElectronicaModal = ({
    getVentaFE,
    showFE,
    handleShowFE,
    handleCloseFE,
    handleClose,
    reset,
    isLoad,
}) => {
    const {
        handleShowFirst,
        isDisabledButton,
        tipoDocumento,
        setPuntoVentaAfip,
        puntoVentas,
        tipoComprobante,
        setTipoComprobante,
        tipoComprobantes,
        setTipoDocumento,
        tipoDocumentos,
        nroDocumento,
        setNroDocumento,
        tipoConcepto,
        setTipoConcepto,
        tipoConceptos,
        condicionIvaReceptor,
        setCondicionIvaReceptor,
        condicionesIvasReceptores,
        finalizarVentaFE
    } = useFacturaElectronicaModal(getVentaFE,
        handleShowFE,
        handleCloseFE,
        handleClose,
        reset,
        isLoad)

    return (
        <Fragment>
            <Button
                onClick={handleShowFirst}
                variant="outline-danger"
                size="lg"
                className="widthCobrar"
                disabled={isDisabledButton}
            >
                Facturacion Electronica{' '}
                <FontAwesomeIcon icon={faFileInvoiceDollar} />
            </Button>
            <Modal
                backdrop="static"
                show={showFE}
                onHide={handleCloseFE}
                size="xl"
                contentClassName="centrado"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Factura Electronica</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* MEDIOS DE PAGO, MONTO, DESCUENTO / RECARGO */}
                    <div className="form-row">
                        <div className="form-group col-md">
                            <label htmlFor="inputPtoVenta">
                                Punto de Venta
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faCashRegister} />
                                </span>
                                <select
                                    id="inputPtoVenta"
                                    className="custom-select"
                                    name="ptoVenta"
                                    value={tipoDocumento}
                                    onChange={(e) => setPuntoVentaAfip(e.target.value)}
                                    disabled={puntoVentas.length === 0}
                                >
                                    {puntoVentas.length === 0 ? (
                                        <option value="">No hay puntos de venta disponibles</option>
                                    ) : (
                                        puntoVentas.map((pv, index) => (
                                            <option key={index} value={pv.Id}>
                                                {pv.Desc}
                                            </option>
                                        ))
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="form-group col-md">
                            <label htmlFor="inputTpoCte">
                                Tipo de Comprobante
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faFileInvoice} />
                                </span>
                                <select
                                    id="inputTpoCte"
                                    className="custom-select"
                                    name="tipoComprobante"
                                    value={tipoComprobante}
                                    onChange={(e) =>
                                        setTipoComprobante(e.target.value)
                                    }
                                >
                                    {tipoComprobantes.map((tc, index) => (
                                        <option key={index} value={tc.Id}>
                                            {tc.Desc}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md">
                            <label htmlFor="inputTpoDoc">
                                Tipo de Documento
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faIdCard} />
                                </span>
                                <select
                                    id="inputTpoDoc"
                                    className="custom-select"
                                    name="tipoDocumento"
                                    value={tipoDocumento}
                                    onChange={(e) =>
                                        setTipoDocumento(e.target.value)
                                    }
                                >
                                    {tipoDocumentos.map((td, index) => (
                                        <option key={index} value={td.Id}>
                                            {td.Desc}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="form-group col-md">
                            <label htmlFor="inputNroDoc">Nro Documento</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faIdCardAlt} />
                                </span>
                                <input
                                    type="number"
                                    step="any"
                                    className="form-control"
                                    id="inputNroDoc"
                                    name="nroDocumento"
                                    placeholder="999999"
                                    value={nroDocumento}
                                    onChange={(e) =>
                                        setNroDocumento(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md">
                            <label htmlFor="inputConcepto">Concepto</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faChevronCircleUp} />
                                </span>
                                <select
                                    id="inputConcepto"
                                    className="custom-select"
                                    name="comprobante"
                                    value={tipoConcepto}
                                    onChange={(e) =>
                                        setTipoConcepto(e.target.value)
                                    }
                                >
                                    {tipoConceptos.map((tc, index) => (
                                        <option key={index} value={tc.Id}>
                                            {tc.Desc}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="form-group col-md">
                            <label htmlFor="inputConcepto">Condicion Iva Receptor</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faAddressCard} />
                                </span>
                                <select
                                    id="inputConcepto"
                                    className="custom-select"
                                    name="comprobante"
                                    value={condicionIvaReceptor}
                                    onChange={(e) =>
                                        setCondicionIvaReceptor(e.target.value)
                                    }
                                >
                                    {condicionesIvasReceptores.map((tc, index) => (
                                        <option key={index} value={tc.Id}>
                                            {tc.Desc}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md">
                            <label htmlFor="inputCantRegistros">
                                Cantidad de Registros
                            </label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faSortAmountDown} />
                                </span>
                                <input
                                    type="number"
                                    step="any"
                                    className="form-control"
                                    id="inputCantRegistros"
                                    name="cantidadRegistros"
                                    placeholder="1"
                                    value={1}
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-outline-primary btn-lg col mr-1 ml-1"
                        onClick={handleCloseFE}
                    >
                        Volver <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    <button
                        className="btn btn-outline-success btn-lg col mr-1 ml-1"
                        onClick={finalizarVentaFE}
                    >
                        Finalizar Venta <FontAwesomeIcon icon={faCheck} />
                    </button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}
export default withRouter(FacturaElectronicaModal)
